module.exports = __webpack_public_path__ + "img/image_2022_07_25T09_12_11_244Z.f0eaf97c.png";